import { FC } from 'react';
import BordOneToneIcon from '../NudosComponents/BordOneToneIcon/BordOneToneIcon';

import './CreditDaysCounter.scss';

interface ICreditDaysCounter {
  showCreditDaysCounter: boolean;
  customClassCreditDaysCounter?: string;
  days: number;
  customText?: string;
}

const CreditDaysCounter: FC<ICreditDaysCounter> = ({
  showCreditDaysCounter,
  customClassCreditDaysCounter = '',
  days,
  customText = ''
}: ICreditDaysCounter) => {
  if (!showCreditDaysCounter || !days) return null;
  return (
    <div className={`creditDaysCounter ${customClassCreditDaysCounter}`}>
      <BordOneToneIcon variant="info" customWidth="16px" fill="white" />
      {customText || 'Orden confirmada automáticamente con acuerdo de pago de'}{' '}
      <span className="daysText">
        {days} {days > 1 ? 'días' : 'día'}.
      </span>
    </div>
  );
};

export default CreditDaysCounter;
